/**
 * Register Page Component
 * User registration form for wholesale customers
 */

import React, { useState } from 'react';


const RegisterPage = () => {
  

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="row justify-content-center w-100">
        <div className="col-md-8 col-lg-6 col-xl-5">
          <div className="card shadow-sm">
            <div className="card-body p-5">
              <div className="text-center mb-4">
                <h2 className="card-title mb-2">Create Account</h2>
                <p className="text-muted">Join our wholesale platform</p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default RegisterPage;